import styled from "styled-components";

export const HistoricalPerformanceChartContainer = styled.div`
  position: relative;
  height: 100%;

  .investment-value {
    .total {
      width: 100%;

      .header-left {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
      }

      .current-balance {
        margin: 0;
        color: rgba(10, 13, 18, 0.5);
        font-family: "Aeonik", sans-serif;
        font-size: 12px;
        font-weight: 400;
        line-height: 18px;
      }

      .amount {
        margin-top: 2px;
        margin-bottom: 4px;
        color: rgba(10, 13, 18, 0.9);
        font-family: "Aeonik", sans-serif;
        font-size: 28px;
        font-weight: 400;
        line-height: 32px;
        .metric-value-decimal {
          font-size: 16px;
          line-height: 1;
          vertical-align: super;
          padding-left: 2px;
        }
      }

      .extra-info {
        line-height: 1;
        margin-bottom: 0px;
        font-size: ${({ theme }) => theme.constants.FONT_SIZE_15};
        font-weight: ${({ theme }) => theme.constants.FONT_WEIGHT_400};
        display: flex;
        align-items: center;
        gap: 6px;

        .icon-wrapper {
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .gain-text {
          font-family: "Geist", "Inter", sans-serif;
          font-size: 14px;
          font-weight: 500;
          line-height: 24px;
        }

        .period-text {
          color: #414651;
          font-family: "Geist", "Inter", sans-serif;
          font-size: 14px;
          font-weight: 400;
          line-height: 20px;
        }

        &.gain {
          .gain-text {
            color: #2d8c44;
          }
          .icon-wrapper {
            color: #3daa57;
          }
        }

        &.loss {
          .gain-text {
            color: #d92d20;
          }
          .icon-wrapper {
            color: #d92d20;
          }
        }

        .benchmark-wrapper {
          display: flex;
          width: 100%;
          flex-wrap: no-wrap;
          align-items: center;
          color: ${({ theme }) => theme.tab.color.quinary};
          font-size: 14px;

          .benchmark {
            border-radius: 25px;
            padding: 10px;
            height: 27px;
            font-size: 14px;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 3px;
            background-color: ${({ theme }) => theme.tab.bg.quaternary};
            color: ${({ theme }) => theme.tab.color.quinary};
          }
        }
      }
    }

    .date {
      font-size: 12px;
      margin-left: 5px;
      color: ${({ theme }) => theme.tab.color.quinary};
    }
  }

  @media (max-width: 820px) {
    .investment-value .total {
      flex-direction: column;
      align-items: flex-start;
    }
  }
`;

export const HeaderComponent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
  margin-top: 12px;
  margin-bottom: 12px;

  .h-performance-filter {
    margin: 1rem 0rem;
  }

  @media (max-width: 576px) {
    flex-direction: column;
    align-items: flex-start;

    .h-performance-filter {
      width: auto;
    }
  }
`;

export const LegendContainer = styled.ul`
  background: ${({ theme }) => theme.button.bg.secondary};
  border-radius: ${({ theme }) => theme.constants.BORDER_RADIUS_8};
  padding: 10px 0;

  li {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .line {
    border-radius: 10px;
    width: 15px;
    height: 2px;
    display: inline-block;
    margin-right: 6px;
  }

  .name {
    color: ${({ theme }) => theme.global.extraInfo.font.color};
    opacity: ${({ theme }) => theme.chart.legend.opacity};
    font-weight: 500;
    font-size: 10px;
  }

  .value {
    font-weight: ${({ theme }) => theme.constants.FONT_WEIGHT_600};
    font-size: 14px;
  }

  .date {
    font-size: 12px;
    margin-left: 5px;
  }

  @media (max-width: 820px) {
    .gain {
      font-size: 12px;
    }
  }
`;
